export default __webpack_public_path__ + "static/media/HeroImage.2730277d.svg";